// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__7TZzD","left":"StickyBox_left__2qMom","right":"StickyBox_right__1NZ9s"};